var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpiltCancelIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_8068",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_8068)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 2C10.1517 2 9.97333 2.00167 9.79833 2.00417L9.285 2.01833L9.03583 2.02917L8.55333 2.0575L8.0925 2.09583C4.105 2.4825 2.4825 4.105 2.09583 8.0925L2.0575 8.55333L2.02917 9.03583C2.025 9.1175 2.02083 9.20083 2.01833 9.285L2.00417 9.79833L2.00083 10.0633L2 10.3333C2 10.515 2.00167 10.6933 2.00417 10.8683L2.01833 11.3817L2.02917 11.6308L2.0575 12.1133L2.09583 12.5742C2.4825 16.5617 4.105 18.1842 8.0925 18.5708L8.55333 18.6092L9.03583 18.6375C9.1175 18.6417 9.20083 18.6458 9.285 18.6483L9.79833 18.6625L10.3333 18.6667L10.8683 18.6625L11.3817 18.6483L11.6308 18.6375L12.1133 18.6092L12.5742 18.5708C16.5617 18.1842 18.1842 16.5617 18.5708 12.5742L18.6092 12.1133L18.6375 11.6308C18.6417 11.5492 18.6458 11.4658 18.6483 11.3817L18.6625 10.8683L18.6667 10.3333L18.6625 9.79833L18.6483 9.285L18.6375 9.03583L18.6092 8.55333L18.5708 8.0925C18.1842 4.105 16.5617 2.4825 12.5742 2.09583L12.1133 2.0575L11.6308 2.02917C11.5478 2.02511 11.4647 2.0215 11.3817 2.01833L10.8683 2.00417L10.6033 2.00083L10.3333 2Z",
    fill: "#FB4945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 8L13 13M13 8L8 13",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpiltCancelIcon);
export default __webpack_public_path__ + "static/media/spilt-cancel-icon.608228873a685b1d8e5cf6044be35926.svg";
export { ForwardRef as ReactComponent };